import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import {
  IActiveFilter,
  IActiveFilterState,
} from '../../../../../interfaces/src/lib/interfaces/index';

const initialState: IActiveFilterState = {
  activeFilterIds: [] as IActiveFilter[],
};

const activeFilterSlice = createSlice({
  name: 'activeFilters',
  initialState,
  reducers: {
    setActiveFilterIds: (state: IActiveFilterState, action: PayloadAction<IActiveFilterState>) => {
      state.activeFilterIds = action.payload.activeFilterIds;

      return state;
    },
  },
});

export const { setActiveFilterIds } = activeFilterSlice.actions;
export const activeFilterReducer = activeFilterSlice.reducer;
